import { useState } from 'react';
import { GradingTypeClient, GradingTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useGradingTypeApi = () => {
    const apiClient = new GradingTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: GradingTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createGradingType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating GradingType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: GradingTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateGradingType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating GradingType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getGradingTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching GradingType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchGradingTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching GradingTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteGradingType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting GradingType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};